import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { casesActions } from "configs";
import {
  generateId,
  StoredAnestheticProtocol,
  useCurrentCase,
  useToast
} from "duck";
import { useUseCalculationsAnestheticProtocolMutation } from "requests";

export const useAddProtocolToCalculations = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { caseId, shouldSync, patientId } = useCurrentCase(medicalCase => ({
    caseId: medicalCase.data._id,
    shouldSync: medicalCase.shouldSync,
    patientId: medicalCase.data.client.patient._id
  }));
  const [
    addProtocolToCalculations,
    { loading }
  ] = useUseCalculationsAnestheticProtocolMutation();
  const toast = useToast({ status: "success" });

  return {
    addProtocol: (protocol: StoredAnestheticProtocol) => {
      if (shouldSync) {
        return addProtocolToCalculations({
          variables: {
            input: { anestheticProtocol: protocol._id, patient: patientId }
          }
        }).then(({ data }) => {
          const medicationCalculations =
            data?.useCalculationsAnestheticProtocol
              ?.calculationsAnestheticProtocol?.medicationCalculations;
          const regionalBlocks =
            data?.useCalculationsAnestheticProtocol
              ?.calculationsAnestheticProtocol?.regionalBlocks;

          if (medicationCalculations && regionalBlocks) {
            dispatch(
              casesActions.addProtocolToCalculations({
                _id: caseId,
                data: { medicationCalculations, regionalBlocks }
              })
            );
            navigate(-1);
            toast({
              description: `${protocol.name} Anesthetic protocol is applied to the case successfully.`
            });
          }
        });
      }

      const medicationCalculations =
        protocol.medicationCalculations?.collection.map(med => ({
          calculationType: med.type,
          fakeId: generateId(),
          concentration: med.concentration,
          dose: med.dose,
          route: med.route,
          medication: med.medication
        })) || [];
      const regionalBlocks =
        protocol.regionalBlocks?.collection.map(block => ({
          type: block.type,
          fakeId: generateId(),
          concentration: block.concentration,
          doseMax: block.doseMax,
          doseMin: block.doseMin,
          volumeToBeInfused: block.volumeToBeInfused,
          medication: block.medication
        })) || [];

      dispatch(
        casesActions.addProtocolToCalculations({
          _id: caseId,
          data: {
            medicationCalculations,
            regionalBlocks
          }
        })
      );
      navigate(-1);
      toast({
        description: `${protocol.name} Anesthetic protocol is applied to the case successfully.`
      });
    },
    loading
  };
};
